import React from 'react';
import ErrorPage from './ErrorPage';

export default function NotFoundPage() {
  return <ErrorPage error="404" />;
}
